import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../store';
import { Spinner, Col, Row } from 'react-bootstrap';
import Loading from '../../facturotopia/loading/Loading';
import PacHitsAssignment from './upsert/PacHitsAssignment';
import PageHeader from '../../support/page-header/PageHeader';

class PacsInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id }
    }

    props.setData(this.state.data);
  }

  componentDidMount() {
    const { data } = this.state;

    if (!!data.alias) {
      return;
    }

    this.props.get(data.id);
  }

  render() {
    const { data = {}, busy } = this.props;

    const edit = {
      pathname: `/admin/pacs/${data.id}/editar`,
      state: {
        data: {...data}
      }
    }

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader to="/admin/pacs" text="Pacs" />

        <h5>
          <Row>
            <Col>
              { !!busy && (
                <Spinner animation="border" role="status" size="sm" className="mr-3">
                  <span className="sr-only">Loading pac info...</span>
                </Spinner>
                )
              }
              { data.nombre || '...' }
            </Col>
            { Guardian.allows('pac.editar') && (
              <Col xs={ 2 } className="text-right">
                <Link className="text-muted"
                  to={ edit }
                >
                  <small>Editar</small>
                </Link>
              </Col>
            )}
          </Row>

        </h5>

        { !!data.nombre && (
          <div>
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <div>
              <strong>Alias: </strong> { data.alias }
              <br />
              <strong>Hits: </strong> { data.hits }
              <br />
              <strong>Timbrados: </strong> { data.timbrados }
              <br />
              <strong>Errores: </strong> { data.errores }
            </div>

            { Guardian.allows('pac.asignar.hits') && (
              <div className="py-3">
                <PacHitsAssignment data={ data } onUpdate={ this.props.setData } />
              </div>
            )}

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Errores</strong>
            </div>

            </div>
          )
        }
      </>
    );
  }
}

const mapState = (state) => {
  return state.admin.pacs.info;
}

const mapActions = (actions) => {
  return actions.admin.pacs.info;
}

export default connect(useStore, mapState, mapActions)(PacsInfo);